import { ComputeImage as ComputeImageSchema, ComputeImage_DiskFormat, ComputeImage_OsDistro, ComputeImage_Visibility } from '@schema';
import { IMAGE_STATUS_GROUPS, IMAGE_STATUS_MAP, IMAGE_TYPE } from '@/common/constants/images.constants';

const mapper = function (image: ComputeImageSchema) {
  const {
    status,
    disk_format: format
  } = image;

  return {
    id: image.id,
    name: image.name,
    status,
    statusText: IMAGE_STATUS_MAP[status].text,
    statusIcon: IMAGE_STATUS_MAP[status].icon,
    isLoading: IMAGE_STATUS_GROUPS.uploading.includes(status) || IMAGE_STATUS_GROUPS.saving.includes(status),
    isActive: IMAGE_STATUS_GROUPS.active.includes(status),
    size: image.size,
    format,
    type: format === ComputeImage_DiskFormat.ISO ? IMAGE_TYPE.ISO : IMAGE_TYPE.TEMPLATE,
    os: image.os_distro || ComputeImage_OsDistro.LINUX,
    tags: image.tags || [],
    minDisk: image.min_disk,
    minRam: image.min_ram,
    virtualSize: image.virtual_size,
    createdAt: image.created_at,
    projectId: image.project_id,
    domainId: image.domain_id,
    isPublic: image.visibility === ComputeImage_Visibility.PUBLIC,
    osType: image.os_type,
    file: image.file,
    traits: image.traits || [],
    uefi: image.hw_firmware_type === 'uefi' || null,
    vtpm: image.hw_tpm_version === '2.0' || null,
    secureBoot: image.os_secure_boot === 'required' || null,
    allowVMPassword: image.allow_set_password,
    username: image.username,
    isRestricted: image.restricted
  };
};

export type ComputeImage = ReturnType<typeof mapper>;

export default mapper;
